<div class="mt-2">
	<form *ngIf="theForm" [formGroup]="theForm">
		<div class="row g-1 mb-2">
			<div *ngIf="showSite" class="col-auto">
				<ng-select [items]="enabledChoices" bindValue="value" bindLabel="label" id="enabledFilter" formControlName="enabledFilter"
					[multiple]="false" (change)="onFormChange()" placeholder="Site Enabled/Disabled">
				</ng-select>
			</div>

			<div *ngIf="showSite" class="col-auto">
				<ng-select [items]="zmTypeChoices" bindValue="value" bindLabel="label" id="zmTypeFilters" formControlName="zmTypeFilters"
					[multiple]="true" [closeOnSelect]="false" (change)="onFormChange()" placeholder="Filter by Type">
				</ng-select>
			</div>

			<div class="col-auto">
				<ng-select [items]="specialChoices" bindValue="value" bindLabel="label" id="specialFilters" formControlName="specialFilters"
					[multiple]="true" (change)="onFormChange()" placeholder="Special">
				</ng-select>
			</div>
		</div>
	</form>

	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow">

					<td class="cp-icon-cell">
						<fa-icon *ngIf="item.is_enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success" placement="end"
							ngbTooltip="User Account Enabled - login permitted"></fa-icon>
						<fa-icon *ngIf="item.is_enabled === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger" placement="end"
							ngbTooltip="User Account Disabled - login not permitted"></fa-icon>
					</td>

					<td class="cp-icon-cell">
						<fa-icon *ngIf="item.sso_id && item.sso_id !== ''" [icon]="['fas', 'sign-in-alt']" size="sm" placement="end"
							ngbTooltip="This User authenticated via Single Sign On">
						</fa-icon>
					</td>

					<td class="cp-icon-cell">
						<fa-icon *ngIf="item.is_admin && item.is_admin === 1" [icon]="['fas', 'hat-wizard']" class="text-primary" size="sm"
							placement="end" ngbTooltip="Site Admin">
						</fa-icon>
					</td>
					<td class="cp-icon-cell" [title]="vt.getZenUserSupportLabel(item, false)">
						{{ vt.getZenUserSupportLabel(item, true) }}
					</td>
					<td class="cp-icon-cell">
						<fa-icon *ngIf="item.is_zixi_admin && item.is_zixi_admin === 1" [icon]="['fas', 'hat-wizard']" class="text-info"
							size="sm" placement="end" ngbTooltip="Zixi Admin">
						</fa-icon>
					</td>

					<td class="text-nowrap">
						<span *ngIf="!item['__portalUser']">{{ item.name }}</span>
						<a *ngIf="item['__portalUser']" [routerLink]="['/' + ac.urls.users, item['__portalUser'].id]" placement="end"
							ngbTooltip="This ZEN Master User is also a ZCP User">
							{{ item.name}}
						</a>
						<fa-icon *ngIf="item['__diffOrgUser']" [icon]="['fas', 'exclamation-triangle']"
							ngbTooltip="The ZCP User is not linked to the Organization that is linked to this ZEN Master site.">
						</fa-icon>
						<fa-icon *ngIf="item['__noOrgUser']" [icon]="['fas', 'exclamation-triangle']" class="text-warning"
							ngbTooltip="The ZCP User is not linked to an Organization.">
						</fa-icon>
					</td>
					<td class="cp-chopped-col-medium">{{ item.email }}</td>

					<td class="text-center">
						<span *ngIf="item['__sinceAdd']">
							{{ item['__sinceAdd'] | number }}
						</span>
					</td>
					<td class="text-center">
						<span *ngIf="item['__sinceLogin'] != null">
							{{ item['__sinceLogin'] | number }}
						</span>
					</td>
					<td>
						<span *ngIf="item['__notificatioState']">
							{{ item['__notificatioState'] }}
						</span>
					</td>

					<td *ngIf="fieldsToShow.includes('__zenPrefix')">
						<a [routerLink]="['/' + ac.urls.zencustomers, item.customer_id]">
							{{ item['__zenPrefix'] }}
							<fa-icon *ngIf="item['__zenEnabled'] === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger"
								placement="end" ngbTooltip="ZEN Master Site Disabled"></fa-icon>
						</a>
					</td>
					<td *ngIf="fieldsToShow.includes('__zenType')">{{ ac.zenMasterTypeLabels[item['__zenType']] }}</td>

					<td *ngIf="fieldsToShow.includes('__roles')">{{ item['__roles'] }}</td>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>